<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mt-1 mal-text custom-title">QHLS സെന്റർ രെജിസ്ട്രേഷൻ</h3>
        </div>
    </div>
    <div class="section pt-0 mt-1 pb-2">
        <div class="card">
            <div class="card-body">
                <Form @submit="handleRegistration" :validation-schema="schema">
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary" for="center_name">
                                Name of Centre
                                <span class="text-danger">*</span>
                            </label>
                            <Field type="text" :disabled="!permissions.edit" class="form-control" name="center_name"
                                v-model="formData.center_name" autocomplete="off" />
                            <ErrorMessage name="center_name" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary" for="center_adress">
                                Address
                                <span class="text-danger">*</span>
                            </label>
                            <Field as="textarea" :disabled="!permissions.edit" class="form-control" rows="5"
                                name="center_adress" v-model="formData.center_adress" />

                            <ErrorMessage name="center_adress" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary" for="center_location">
                                Location
                                <!-- <span class="text-danger">*</span> -->
                            </label>
                            <Field type="text" :disabled="!permissions.edit" class="form-control" name="center_location"
                                v-model="formData.center_location" autocomplete="off" placeholder="Copy & Paste Google Map Link" />
                            <ErrorMessage name="center_location" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary" for="center_type">
                                Type of Centre
                                <span class="text-danger">*</span>
                            </label>
                            <div class="form-check form-check-inline">
                                <Field as="input" type="radio" class="form-check-input" value="Madrasa"
                                    name="center_type" id="center_type_1" v-model="formData.center_type" />
                                <label class="form-check-label" for="center_type_1">Madrasa &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <Field as="input" type="radio" class="form-check-input" value="Masjid"
                                    name="center_type" id="center_type_2" v-model="formData.center_type" />
                                <label class="form-check-label" for="center_type_2">Masjid &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <Field as="input" type="radio" class="form-check-input" value="Own" name="center_type"
                                    id="center_type_3" v-model="formData.center_type" />
                                <label class="form-check-label" for="center_type_3">Own &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <Field as="input" type="radio" class="form-check-input" value="Rent" name="center_type"
                                    id="center_type_4" v-model="formData.center_type" />
                                <label class="form-check-label" for="center_type_4">Rent &nbsp;</label>
                            </div>
                            <br />
                            <ErrorMessage name="center_type" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary" for="class_type">
                                Type of class
                                <span class="text-danger">*</span>
                            </label>
                            <div class="form-check form-check-inline">
                                <Field as="input" type="radio" class="form-check-input" value="Ladies Only"
                                    name="class_type" id="class_type_1" v-model="formData.class_type"
                                    @change="onClassTypeChange" />
                                <label class="form-check-label" for="class_type_1">Ladies Only &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <Field as="input" type="radio" class="form-check-input" value="Gents Only"
                                    name="class_type" id="class_type_2" v-model="formData.class_type"
                                    @change="onClassTypeChange" />
                                <label class="form-check-label" for="class_type_2">Gents Only &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <Field as="input" type="radio" class="form-check-input" value="Ladies and Gents"
                                    name="class_type" id="class_type_3" v-model="formData.class_type"
                                    @change="onClassTypeChange" />
                                <label class="form-check-label" for="class_type_3">Ladies and Gents &nbsp;</label>
                            </div>
                            <br />
                            <ErrorMessage name="class_type" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary" for="no_of_rooms">
                                No. Rooms
                                <span class="text-danger">*</span>
                            </label>
                            <Field type="number" :disabled="!permissions.edit" class="form-control" name="no_of_rooms"
                                v-model="formData.no_of_rooms" placeholder="00" autocomplete="off" />
                            <ErrorMessage name="no_of_rooms" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary" for="no_of_benches">
                                No. Of Benches/Chairs
                                <span class="text-danger">*</span>
                            </label>
                            <Field type="number" :disabled="!permissions.edit" class="form-control" name="no_of_benches"
                                v-model="formData.no_of_benches" placeholder="00" autocomplete="off" />
                            <ErrorMessage name="no_of_benches" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary" for="no_of_desks">
                                No. Of desks
                                <span class="text-danger">*</span>
                            </label>
                            <Field type="number" :disabled="!permissions.edit" class="form-control" name="no_of_desks"
                                v-model="formData.no_of_desks" placeholder="00" autocomplete="off" />
                            <ErrorMessage name="no_of_desks" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary" for="no_of_estimated_registrations">
                                Estimated no. Of registration
                                <span class="text-danger">*</span>
                            </label>
                            <Field type="number" :disabled="!permissions.edit" class="form-control"
                                name="no_of_estimated_registrations" v-model="formData.no_of_estimated_registrations"
                                placeholder="00" autocomplete="off" />
                            <ErrorMessage name="no_of_estimated_registrations" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary" for="for_what">
                                Other Facilities
                                <span class="text-danger">*</span>
                            </label>
                            <div class="form-check form-check-inline">
                                <input type="checkbox" :disabled="!permissions.edit" class="form-check-input" value="Y"
                                    name="office_room" id="office_room_1" v-model="formData.office_room"
                                    @change="onFacilityChange('office_room')" />
                                <label class="form-check-label" for="office_room_1">Office Room &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="checkbox" :disabled="!permissions.edit" class="form-check-input" value="Y"
                                    name="library" id="library_1" v-model="formData.library"
                                    @change="onFacilityChange('library')" />
                                <label class="form-check-label" for="library_1">Library &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="checkbox" :disabled="!permissions.edit" class="form-check-input" value="Y"
                                    name="toilet" id="toilet_1" v-model="formData.toilet"
                                    @change="onFacilityChange('toilet')" />
                                <label class="form-check-label" for="toilet_1">Toilet &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="checkbox" :disabled="!permissions.edit" class="form-check-input" value="Y"
                                    name="rest_area" id="rest_area_1" v-model="formData.rest_area"
                                    @change="onFacilityChange('rest_area')" />
                                <label class="form-check-label" for="rest_area_1">Rest Area (Dining) &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="checkbox" :disabled="!permissions.edit" class="form-check-input" value="Y"
                                    name="projector" id="projector_1" v-model="formData.projector"
                                    @change="onFacilityChange('projector')" />
                                <label class="form-check-label" for="projector_1">Projector/TV &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="checkbox" :disabled="!permissions.edit" class="form-check-input" value="Y"
                                    name="board" id="board_1" v-model="formData.board"
                                    @change="onFacilityChange('board')" />
                                <label class="form-check-label" for="board_1">Black or white board &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="checkbox" :disabled="!permissions.edit" class="form-check-input" value="Y"
                                    name="fan_ac" id="fan_ac_1" v-model="formData.fan_ac"
                                    @change="onFacilityChange('fan_ac')" />
                                <label class="form-check-label" for="fan_ac_1">Fan or AC &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="checkbox" :disabled="!permissions.edit" class="form-check-input" value="Y"
                                    name="drinking_water" id="drinking_water_1" v-model="formData.drinking_water"
                                    @change="onFacilityChange('drinking_water')" />
                                <label class="form-check-label" for="drinking_water_1">Drinking Water &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="checkbox" :disabled="!permissions.edit" class="form-check-input" value="Y"
                                    name="none_of_above" id="none_of_above_1" v-model="formData.none_of_above"
                                    @change="onNoneOfAboveChange" />
                                <label class="form-check-label" for="none_of_above_1">None of above &nbsp;</label>
                            </div>

                        </div>
                        <ErrorMessage name="for_what_other" class="error-feedback" />
                    </div>
                    <div class="section-title text-primary">Coordinators <span class="text-muted small">(At least one required)</span></div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary" for="receipt_number">
                                ORG
                            </label>
                            <v-select label="text" :disabled="!permissions.edit" class="mt-1" :filterable="true"
                                v-model="org_member" :value="org_member" :options="org_member_list"
                                @search="(q) => getTextList(q, 1)">
                                <template>Type to search...
                                </template>
                                <template>
                                    <div class="d-center">
                                        {{ member && member.org_member ? member.org_member : '' }}</div>
                                </template>
                            </v-select>
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary" for="receipt_number">
                                Youth
                            </label>
                            <v-select label="text" :disabled="!permissions.edit" class="mt-1" :filterable="true"
                                v-model="youth_member" :value="youth_member" :options="youth_member_list"
                                @search="(q) => getTextList(q, 2)">
                                <template>
                                    Type to search...
                                </template>
                                <template>
                                    <div class="d-center">
                                        {{ member && member.name ? member.name : '' }}</div>
                                </template>
                            </v-select>
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary" for="womens_member">
                                Women's
                            </label>
                            <v-select label="text" :disabled="!permissions.edit" class="mt-1" :filterable="true"
                                v-model="womens_member" :value="womens_member" :options="womens_member_list"
                                @search="(q) => getTextList(q, 4)">
                                <template>
                                    Type to search...
                                </template>
                                <template>
                                    <div class="d-center">
                                        {{ womens_member && womens_member.name ? womens_member.name : '' }}</div>
                                </template>
                            </v-select>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading"
                        v-if="permissions.edit">
                        <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                        <span>Save</span>
                    </button>
                </Form>
            </div>
        </div>
    </div>

    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import {
    Form,
    Field,
    ErrorMessage
} from "vee-validate";
import * as yup from "yup";
import UserService from "../../services/user.service";
import $ from "jquery";
import vSelect from 'vue-select'
import AlertModel from "./../layouts/AlertModel.vue";
import DialogModel from "./../layouts/DialogModel.vue";
export default {
    name: "Admin List",
    props: {
        unit_id: null
    },
    components: {
        Form,
        Field,
        vSelect,
        ErrorMessage,
        AlertModel,
        DialogModel,
    },
    data() {
        const schema = yup.object().shape({
            center_name: yup.string().required("ഫിൽ ചെയ്യുക!"),
            center_adress: yup.string().required("ഫിൽ ചെയ്യുക!"),
            center_type: yup.string().required("ഒന്ന് സെലക്ട് ചെയുക!"),
            class_type: yup.string().required("ഒന്ന് സെലക്ട് ചെയുക!"),
            no_of_rooms: yup.string().required("ഫിൽ ചെയ്യുക!"),
            no_of_benches: yup.string().required("ഫിൽ ചെയ്യുക!"),
            no_of_desks: yup.string().required("ഫിൽ ചെയ്യുക!"),
            no_of_estimated_registrations: yup.string().required("ഫിൽ ചെയ്യുക!"),

        });
        return {
            loading: false,
            schema,
            user_level: "",
            unit: [],
            alert_type: "",
            alert_message: "",
            dialog_message: "",
            dialog_action: "",
            dialog_action_params: [],
            relief_reason_list: [],
            relief_type_list: [],
            children_enable: false,
            formData: {
                change_level: '',
                center_name: '',
                center_adress: '',
                center_location: '',
                center_type: '',
                class_type: '',
                no_of_rooms: '',
                no_of_benches: '',
                no_of_desks: '',
                no_of_estimated_registrations: '',
                office_room: '',
                library: '',
                toilet: '',
                rest_area: '',
                projector: '',
                board: '',
                fan_ac: '',
                drinking_water: '',
                none_of_above: '',
                org_cordinator: '',
                youth_cordinator: '',
                student_cordinator: '',
            },
            reliefFamily: [],
            old_child_count: 0,
            editable_id: '',
            profile_image: null,
            profile_file: null,
            profile_image_save: false,
            profile_image_uploaded: false,
            org_member_list: [],
            org_member: [],
            youth_member_list: [],
            youth_member: [],
            womens_member_list: [],
            womens_member: [],
            old_duty: [],
            new_duty: [],
            requestData: [],
            country_code_list: [],
            profile: [],
            student_cordinator: '',
            permissions: {
                edit: true
            }
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        childLength() {
            return parseInt(this.formData.lessthan_16_count);
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
        } else {
            this.user_level = parseInt(this.$route.params.sub_level);
            if (this.unit_id == this.currentUser.unit_id || this.currentUser.user_level == 4) {
                this.editable = true;
            } else {
                this.editable = false;
            }



            this.$root.updateParent("QHLS Centre Registration");
            if (this.$route.params.id) {
                this.getCreCenterData(this.$route.params.id);
            } else {
                // Only Unit (Level 4) selection is allowed
                this.formData.change_level = 4;
            }
            this.profile = JSON.parse(localStorage.getItem("my_profile"));

        }

        window.onpopstate = function () {
            if ($("body").hasClass("modal-open")) {
                location.reload();
            }
        };
    },
    methods: {
        changeOld() {
            this.formData.new_department = this.formData.old_department;
            this.formData.new_duty = this.formData.old_duty;
        },
        uploadImage(event) {
            var file = event.target.files[0];
            this.profile_file = file;
            this.profile_image = URL.createObjectURL(file);
            this.profile_image_save = true;
        },
        getDepartments(member_id, user_level) {
            if (this.formData.for_what == '4' || this.formData.for_what == '3') {
                return 0;
            }
            this.message = '';
            let data = {
                member_id: member_id,
                user_level: user_level
            }
            UserService.authPostRequest('get-department-by-member', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.old_department_list = response.data.data.departments;
                        this.old_duty = response.data.data.duty;

                        this.new_department_list = response.data.data.departments;
                        this.new_duty = response.data.data.duty;
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getTextList(event, wing) {
            const q = typeof event === 'string' ? event : '';
            let user_level = this.formData.change_level;
            let user_level_id = 0;
            if (user_level == 1) {
                user_level_id = 0;
            } else if (user_level == 2) {
                user_level_id = this.currentUser.district_id;
            } else if (user_level == 3) {
                user_level_id = this.currentUser.zone_id;
            } else if (user_level == 4) {
                user_level_id = this.currentUser.unit_id;
            }

            this.message = '';
            let data = {
                type: 'members',
                q: q,
                filter: 'inside',
                user_level_id: user_level_id,
                user_level: user_level,
                wing: wing,
            }
            UserService.authPostRequest('get-members-executives-by-id', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        if (wing == 1) {
                            this.org_member_list = response.data.data.list;
                        } else if (wing == 2) {
                            this.youth_member_list = response.data.data.list;
                        } else if (wing == 4) {
                            this.womens_member_list = response.data.data.list;
                        }
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getComboboxValues(code, id = null) {
            var data = {
                code: code,
                type_id: id,
            };
            UserService.getCombobox(data).then(
                (response) => {
                    switch (code) {
                        case "RELIEF_REASON":
                            this.relief_reason_list = response.data.data.list.options;
                            break;
                        case "RELIEF_TYPE":
                            this.relief_type_list = response.data.data.list.options;
                            break;
                        case "COUNTRY_CODE":
                            this.country_code_list = response.data.data.list.options;
                            break;
                        default:
                            break;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.messafe =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getStudentCordinator() {
            let user_level = this.formData.change_level;
            console.log(user_level);
            let user_level_id = 0;
            if (user_level == 1) {
                user_level_id = 0;
            } else if (user_level == 2) {
                user_level_id = this.currentUser.district_id;
            } else if (user_level == 3) {
                user_level_id = this.currentUser.zone_id;
            } else if (user_level == 4) {
                user_level_id = this.currentUser.unit_id;
            }

            let data = {
                user_level: user_level,
                user_level_id: user_level_id
            }
            UserService.authPostRequest('get-student-cordinator', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        if (response.data.data.member) {
                            this.student_cordinator = response.data.data.member.name;
                            this.formData.student_cordinator = response.data.data.member.id;
                        }
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        checkStudent() {
            let stud_items = false;
            this.formData.relief_types.forEach(element => {
                this.relief_type_list.forEach(element_ => {
                    if (element_.id == element) {
                        if (element_.item_value == 'student') {
                            stud_items = true;
                        }
                    }
                });
            });

            return stud_items;
        },
        getChild(type = null, count_inc = null) {
            if (type == "student") {
                if (!this.formData.lessthan_16_count) {
                    this.formData.relief_types.pop();
                    this.alert_type = "Warning";
                    this.alert_message = "16 വയസ്സിനു താഴെ ഉള്ള കുട്ടികളുടെ എണ്ണം നൽകുക.";
                    this.$refs.alert_model.openModel();
                } else {
                    if (this.formData.child.length > 0) {
                        for (let i = (this.formData.child.length + 1); i <= parseInt(this.formData.lessthan_16_count); i++) {
                            this.formData.child.push({
                                name: '',
                                age: '',
                                sex: '',
                                editable_id: null
                            });
                        }
                    } else {
                        for (let i = 1; i <= parseInt(this.formData.lessthan_16_count); i++) {
                            this.formData.child.push({
                                name: '',
                                age: '',
                                sex: '',
                                editable_id: null
                            });
                        }
                    }

                    this.old_child_count = parseInt(this.formData.lessthan_16_count);
                }
            } else if (count_inc && this.children_enable) {
                let count = this.formData.child.length;
                for (let i = (count + 1); i <= parseInt(this.formData.lessthan_16_count); i++) {
                    this.formData.child.push({
                        name: '',
                        age: '',
                        sex: '',
                        editable_id: null
                    });
                }
                this.old_child_count = parseInt(this.formData.lessthan_16_count);
            }
            if (this.checkStudent()) {
                this.children_enable = true;
            } else {
                this.children_enable = false;
            }

            console.log(this.formData.child);

        },
        onNoneOfAboveChange() {
            if (this.formData.none_of_above) {
                this.formData.office_room = false;
                this.formData.library = false;
                this.formData.toilet = false;
                this.formData.rest_area = false;
                this.formData.projector = false;
                this.formData.board = false;
                this.formData.fan_ac = false;
                this.formData.drinking_water = false;
            }
        },
        onFacilityChange(field) {
            if (this.formData[field]) {
                this.formData.none_of_above = false;
            }
        },
        onClassTypeChange() {
            // Coordinator fields are always shown; no reset needed on class type change.
        },
        validateMemberSelections() {
            const hasOrg = this.org_member && (this.org_member.id || this.org_member.value);
            const hasYouth = this.youth_member && (this.youth_member.id || this.youth_member.value);
            const hasWomens = this.womens_member && (this.womens_member.id || this.womens_member.value);
            if (!hasOrg && !hasYouth && !hasWomens) {
                this.alert_type = "Warning";
                this.alert_message = "Please select at least one Coordinator (ORG, Youth, or Women's).";
                this.$refs.alert_model.openModel();
                return false;
            }
            return true;
        },
        handleRegistration(data) {
            if (!this.validateMemberSelections()) {
                return;
            }
            console.log(data);
            this.loading = true;
            const formData_ = new FormData();
            if (this.editable_id) {
                formData_.append('editable_id', this.editable_id);
            }

            let user_level = this.formData.change_level;
            let user_level_id = 0;
            if (user_level == 1) {
                user_level_id = 0;
            } else if (user_level == 2) {
                user_level_id = this.currentUser.district_id;
            } else if (user_level == 3) {
                user_level_id = this.currentUser.zone_id;
            } else if (user_level == 4) {
                user_level_id = this.currentUser.unit_id;
            }

            formData_.append('type', 'QHLS');
            formData_.append('user_level', user_level);
            formData_.append('user_level_id', user_level_id);

            formData_.append('center_level', this.formData.change_level);
            formData_.append('center_name', this.formData.center_name);
            formData_.append('center_adress', this.formData.center_adress);
            formData_.append('center_location', this.formData.center_location);

            formData_.append('center_type', this.formData.center_type);
            formData_.append('class_type', this.formData.class_type);

            formData_.append('no_of_rooms', this.formData.no_of_rooms);
            formData_.append('no_of_benches', this.formData.no_of_benches);
            formData_.append('no_of_desks', this.formData.no_of_desks);
            formData_.append('no_of_estimated_registrations', this.formData.no_of_estimated_registrations);

            formData_.append('office_room', this.formData.office_room);
            formData_.append('library', this.formData.library);
            formData_.append('toilet', this.formData.toilet);
            formData_.append('rest_area', this.formData.rest_area);
            formData_.append('projector', this.formData.projector);
            formData_.append('board', this.formData.board);
            formData_.append('fan_ac', this.formData.fan_ac);
            formData_.append('drinking_water', this.formData.drinking_water);
            formData_.append('none_of_above', this.formData.none_of_above);

            const orgId = (this.org_member && (this.org_member.id || this.org_member.value)) || null;
            const youthId = (this.youth_member && (this.youth_member.id || this.youth_member.value)) || null;
            const womensId = (this.womens_member && (this.womens_member.id || this.womens_member.value)) || null;
            if (orgId) formData_.append('org_cordinator', orgId);
            if (youthId) formData_.append('youth_cordinator', youthId);
            if (womensId) formData_.append('women_cordinator', womensId);

            UserService.authPostRequest("store-cre-center", formData_).then(
                (response) => {
                    if (response.data.status == "success") {
                        this.alert_type = "Success";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        if (!this.editable_id) {
                            this.org_member_list = [];
                            this.org_member = [];
                            this.youth_member_list = [];
                            this.youth_member = [];
                            this.womens_member_list = [];
                            this.womens_member = [];
                            this.formData = {
                                change_level: this.formData.change_level,
                                center_name: '',
                                center_adress: '',
                                center_location: '',
                                center_type: '',
                                class_type: '',
                                no_of_rooms: '',
                                no_of_benches: '',
                                no_of_desks: '',
                                no_of_estimated_registrations: '',
                                office_room: '',
                                library: '',
                                toilet: '',
                                rest_area: '',
                                projector: '',
                                board: '',
                                fan_ac: '',
                                drinking_water: '',
                                none_of_above: '',
                                org_cordinator: '',
                                youth_cordinator: '',
                                student_cordinator: '',
                                women_cordinator: '',
                            };
                        }

                        // setTimeout(() => {
                        //     location.replace('/org/'+parseInt(this.$route.params.sub_level)+'/'+parseInt(this.$route.params.id)+'/request-list');
                        // }, 1500);
                        this.loading = false;
                    } else if (response.data.status == "warning") {
                        this.alert_type = "Warning";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = "Error";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        changeUserLevel() {
        },
        getCreCenterData(id) {
            let data = {
                id: id
            }
            UserService.authPostRequest('show-cre-center', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.requestData = response.data.data.center;
                        this.permissions = response.data.data.permissions;
                        // Force Unit (Level 4) selection only
                        this.formData.change_level = '4';
                        this.formData.center_name = this.requestData.center_name;
                        this.formData.center_adress = this.requestData.center_adress;
                        this.formData.center_location = this.requestData.center_location;
                        this.formData.center_type = this.requestData.center_type;
                        this.formData.class_type = this.requestData.class_type;
                        this.formData.no_of_rooms = this.requestData.no_of_rooms;
                        this.formData.no_of_benches = this.requestData.no_of_benches;
                        this.formData.no_of_desks = this.requestData.no_of_desks;
                        this.formData.no_of_estimated_registrations = this.requestData.no_of_estimated_registrations;
                        this.formData.office_room = this.requestData.office_room == 'Y' ? true : false;
                        this.formData.library = this.requestData.library == 'Y' ? true : false;
                        this.formData.toilet = this.requestData.toilet == 'Y' ? true : false;
                        this.formData.rest_area = this.requestData.rest_area == 'Y' ? true : false;
                        this.formData.projector = this.requestData.projector == 'Y' ? true : false;
                        this.formData.board = this.requestData.board == 'Y' ? true : false;
                        this.formData.fan_ac = this.requestData.fan_ac == 'Y' ? true : false;
                        this.formData.drinking_water = this.requestData.drinking_water == 'Y' ? true : false;
                        this.formData.none_of_above = this.requestData.none_of_above == 'Y' ? true : false;
                        this.editable_id = this.requestData.id;

                        const orgMemberSource = this.requestData.org_member || this.requestData.coordinator_org_member;
                        if (orgMemberSource) {
                            this.org_member = {
                                id: orgMemberSource.id,
                                member_id: orgMemberSource.id,
                                text: orgMemberSource.name + '-' + orgMemberSource.mobile,
                                mobile: orgMemberSource.mobile,
                                country_code: orgMemberSource.country_code
                            }
                            this.org_member_list.push(this.org_member);
                        }

                        const youthMemberSource = this.requestData.youth_member || this.requestData.coordinator_youth_member;
                        if (youthMemberSource) {
                            this.youth_member = {
                                id: youthMemberSource.id,
                                member_id: youthMemberSource.id,
                                text: youthMemberSource.name + '-' + youthMemberSource.mobile,
                                mobile: youthMemberSource.mobile,
                                country_code: youthMemberSource.country_code
                            }
                            this.youth_member_list.push(this.youth_member);
                        }

                        const womenMemberSource = this.requestData.women_member
                            || this.requestData.coordinator_women_member;
                        if (womenMemberSource) {
                            this.womens_member = {
                                id: womenMemberSource.id,
                                member_id: womenMemberSource.id,
                                text: womenMemberSource.name + '-' + womenMemberSource.mobile,
                                mobile: womenMemberSource.mobile,
                                country_code: womenMemberSource.country_code
                            }
                            this.womens_member_list.push(this.womens_member);
                        } else if (this.requestData.girls_member) {
                            this.womens_member = {
                                id: this.requestData.girls_member.id,
                                member_id: this.requestData.girls_member.id,
                                text: this.requestData.girls_member.name + '-' + this.requestData.girls_member.mobile,
                                mobile: this.requestData.girls_member.mobile,
                                country_code: this.requestData.girls_member.country_code
                            }
                            this.womens_member_list.push(this.womens_member);
                        }

                        // if (this.formData.for_what == 1 || this.formData.for_what == 2) {
                        //     this.getDepartments(this.requestData.member_to_change.member_id, this.requestData.user_level);
                        // }

                        // if (this.requestData.new_member_to_change) {
                        //     this.new_member = {
                        //         id: this.requestData.new_member_to_change.member_id,
                        //         member_id: this.requestData.new_member_to_change.member_id,
                        //         text: this.requestData.new_member_to_change.member.name,
                        //         mobile: this.requestData.new_member_to_change.member.mobile,
                        //         country_code: this.requestData.new_member_to_change.member.country_code
                        //     }
                        //     this.new_member_list.push(this.new_member);
                        // }


                        // if (this.requestData.departments_to_change) {
                        //     this.formData.old_department = JSON.parse(this.requestData.departments_to_change);
                        // }
                        // if (this.requestData.new_departments_to_change) {
                        //     this.formData.new_department = JSON.parse(this.requestData.new_departments_to_change);
                        // }
                        // if (this.requestData.designations_to_change) {
                        //     this.formData.old_duty = JSON.parse(this.requestData.designations_to_change);
                        //     console.log(this.formData.old_duty);
                        // }
                        // if (this.requestData.new_designations_to_change) {
                        //     this.formData.new_duty = JSON.parse(this.requestData.new_designations_to_change);
                        // }

                        // this.formData.family_leader_house_name = this.reliefFamily.family_head_surname;
                        // this.formData.family_leader_mobile = this.reliefFamily.family_contact;
                        // this.formData.place = this.reliefFamily.family_place;
                        // this.formData.panjayath = this.reliefFamily.family_panchayath;
                        // this.formData.zakath = this.reliefFamily.zakath_eligible;
                        // this.formData.total_count = this.reliefFamily.family_members_count;
                        // this.formData.lessthan_16_count = this.reliefFamily.boys_count;
                        // this.formData.yatheem_count = this.reliefFamily.orphan_count;
                        // this.formData.widow_count = this.reliefFamily.widow_count;
                        // this.editable_id = this.reliefFamily.id;
                        // if (this.reliefFamily.family_reason_to_include) {
                        //     this.formData.relief_reason = JSON.parse(this.reliefFamily.family_reason_to_include);
                        // }
                        // if (this.reliefFamily.relief_types) {
                        //     this.formData.relief_types = JSON.parse(this.reliefFamily.relief_types);
                        //     if (response.data.data.child.length > 0) {
                        //         response.data.data.child.forEach(element => {
                        //             this.formData.child.push({
                        //                 name: element.child_name,
                        //                 age: element.child_age,
                        //                 sex: element.child_sex,
                        //                 editable_id: element.id
                        //             });
                        //         });
                        //         this.old_child_count = response.data.data.child.length;
                        //         this.children_enable = true;
                        //     }
                        // }
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
    },
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.green-tick {
    font-size: 18px;
    color: darkgreen;
}

.red-cross {
    font-size: 18px;
    color: red;
}

.qhls-text {
    font-style: italic;
    color: #266bd1;
}

.custom-file-upload {
    position: relative;
    display: flex;
    width: 50%;
    height: 100px;
}

.form-check-input:disabled~.form-check-label,
.form-check-input[disabled]~.form-check-label {
    opacity: 1;
}

.form-check-input:disabled~.form-check-label,
.form-check-input[disabled]~.form-check-label {
    color: #060606;
}
</style>
